import { TextField, Switch, Grid, Typography, Autocomplete } from "@mui/material";
import * as React from 'react';
import { useMediaQuery } from "@mui/material";
import ImageAvatars from "./image-avatar-component";
import { useSelector, useDispatch } from "react-redux";
import { useTranslate } from "react-redux-multilingual";
import {
    fetchCompanyLocationData,
    setCompanyLocationInfo,
    setcompanystateDataArray,
    setcheckBoxChecked,
    setcompanycityDataArray,
    setcompanyCityError,
    setthrowInvalidZipcodeError_Company,
    fetchCompanyState,
    comfetchCities,
    setCompanyName,
    setGstNumber
} from "../reducers/global-reducer";

const initialValues = {
    CountryId: "",
    StateId: "",
    CityId: "",
    ZipCode: "",
    Address1: "",
    Address2: ""
}

const OrganisationInformation = ({ formik, route, serviceID }) => {

    const t = useTranslate();
    const matches = useMediaQuery('(min-width:500px)');
    const store = useSelector(state => state);
    const dispatch = useDispatch();
    const [comParamId, setComParamId] = React.useState("")

    const {
        companyCountryDataArray,
        companyLocationInfo,
        imageUrlCompany,
        checkBoxChecked,
        companystateDataArray,
        companycityDataArray,
        companyCountriesArray,
        companyCityError,
        throwInvalidZipcodeError_Company,
        comStateArray,
        comStateData,
        comCityArray,
    } = store.globalreducer


    const { CountryId, StateId, CityId } = companyLocationInfo
    const [initialCountry, setInitialCountry] = React.useState(false);
    const [initialState, setInitialStete] = React.useState(false);
    const [initialCity, setInitialCity] = React.useState(false);

    React.useEffect(() => {
        if (CountryId === null || initialCountry) {
            dispatch(setCompanyLocationInfo({ ...companyLocationInfo, StateId: "", CityId: "", }))
            formik.values.ZipCode = "";
            setInitialCountry(false)
        }
    }, [CountryId])

    React.useEffect(() => {
        if (StateId === null || initialState) {
            dispatch(setCompanyLocationInfo({ ...companyLocationInfo, CityId: "", ZipCode: "" }))
            formik.values.ZipCode = "";
            setInitialStete(false)
        }

    }, [StateId])

    React.useEffect(() => {
        if (CityId === null || initialCity) {
            formik.values.ZipCode = "";
            setInitialCity(false)
        }

    }, [CityId])

    // set selected country to for fetching state details
    const handleCountryName = (value) => {
        setInitialCountry(true)
        dispatch(setCompanyLocationInfo({ ...companyLocationInfo, "CountryId": value }))
        const CountryId = companyCountryDataArray.filter(item => item.countryname === value).map(item => item.countryid)
        setComParamId(CountryId)
        const data = {
            "CountryId": CountryId,
            "multilingualMessage": t
        }

        dispatch(fetchCompanyState(data))
    }

    // set selected state to for fetching city details
    const handleStateName = (value) => {
        setInitialStete(true)
        dispatch(setCompanyLocationInfo({ ...companyLocationInfo, "StateId": value }))
        const states = comStateData.filter(item => item.statename === value).map(item => item.stateid).map(item => item)[0]
        const tem = comParamId[0]
        dispatch(comfetchCities(tem, Number(states), t))
    }

    const handleCityName = (value, path) => {
        setInitialCity(true)
        if (!value) {
            dispatch(setCompanyLocationInfo({ ...companyLocationInfo, "CityId": "" }))
            return
        }
        if (companyCityError) {
            dispatch(setcompanyCityError(false))
        }
        dispatch(setCompanyLocationInfo({ ...companyLocationInfo, "CityId": value }))
    }

    const handleChangeZipcode = (e) => {
        dispatch(setthrowInvalidZipcodeError_Company(false))
        formik.handleChange(e)
    }

    const handleChecked = (e) => {
        dispatch(setcheckBoxChecked(e.target.checked))
        if (e.target.checked) {
            dispatch(setCompanyLocationInfo(companyLocationInfo))
            dispatch(setcompanystateDataArray(companystateDataArray))
            dispatch(setcompanycityDataArray(companycityDataArray))

        } else {
            dispatch(setCompanyLocationInfo(initialValues));
            dispatch(setcompanystateDataArray([]))
            dispatch(setcompanycityDataArray([]))
        }
    }

    React.useEffect(() => {
        dispatch(fetchCompanyLocationData(t))
    }, [checkBoxChecked])

    React.useEffect(() => {
        dispatch(setCompanyName(formik.values.companyName))
        dispatch(setGstNumber(formik.values.gstNumber))
    }, [[!checkBoxChecked]])

    const style ={
        compname:{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` },
        pass: { margin: '7px', width: `${matches ? '33rem' : '16rem'}` },
        passgrid:{ marginTop: '7px', },
        country:{ margin: '7px', textAlign: 'left', width: '16rem' },
        city:{ margin: '7px', textAlign: 'left', width: '16rem' },
        ZipCode:{ margin: '7px', width: '16rem' },
        address:{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` },
        address2:{ margin: '7px', width: `${matches ? '33rem' : '16rem'}` }
    }

    return (
        <form noValidate>
            <div>
                <div>
                    {/* Organization image */}
                    <ImageAvatars route={route} srcFile={imageUrlCompany} />
                </div>
                {/* Company Name */}
                <div className="password-grid-organisation">
                    <TextField
                        sx={style.compname}
                        label={t('companyName')}
                        required={!serviceID.includes("JODOLINKINDIVIDUAL")}
                        id="companyName"
                        name="companyName"
                        value={formik.values.companyName}
                        onChange={formik.handleChange}
                        error={formik.touched.companyName && Boolean(formik.errors.companyName)}
                        helperText={formik.touched.companyName && formik.errors.companyName}
                        disabled={route === "existingUser" ? true : false}
                        inputProps={{ maxLength: 250 }}
                        InputLabelProps={{
                            sx: {
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            },
                            '&.MuiInputLabel-shrink': {
                                fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                              },
                              transition: 'all 0.2s ease', // Make it a bit bigger when focused
                            
                        }}
                    />
                </div>
                {/* Password */}
                <div className="password-grid">
                    <TextField
                        sx={style.pass}
                        label={t('taxNo')}
                        id="gstNumber"
                        name="gstNumber"
                        value={formik.values.gstNumber}
                        onChange={formik.handleChange}
                        error={formik.touched.gstNumber && Boolean(formik.errors.gstNumber)}
                        helperText={formik.touched.gstNumber && formik.errors.gstNumber}
                        disabled={route === "existingUser" ? true : false}
                        inputProps={{ maxLength: 250 }}
                    />
                </div>
                <div className="password-grid">
                    <Typography variant="normal" sx={style.passgrid}>{t('billingDetailsLocationMsg')}</Typography>
                    <Switch checked={checkBoxChecked} onChange={handleChecked} />
                </div>
                {
                    !checkBoxChecked &&
                    <>
                        <Grid container justifyContent={'center'}>
                            {/* Country select dropdown */}
                            <Autocomplete
                                options={companyCountriesArray}
                                filterOptions={(countriesArray, state) => {
                                    const inputValue = state.inputValue.toLowerCase();
                                    return countriesArray.filter(option =>
                                        option.toLowerCase().startsWith(inputValue)
                                    );
                                }}
                                isOptionEqualToValue={(option, value) => option === value}
                                onChange={(e, v) => handleCountryName(v)}
                                disabled={(route === "existingUser" ? true : false)}
                                value={CountryId}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        sx={style.country}
                                        label={t('country')}
                                        fullWidth={false}
                                        required
                                        disabled={(route === "existingUser" ? true : false)}
                                        autoComplete={false}
                                        InputLabelProps={{
                                            sx: {
                                                '& .MuiFormLabel-asterisk': {
                                                    color: 'red',
                                                },
                                            },
                                            '&.MuiInputLabel-shrink': {
                                                fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                              },
                                              transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                            
                                        }}
                                    />
                                )}
                            />
                            {/* State Select dropdown */}
                            <Autocomplete
                                options={comStateArray}
                                filterOptions={(countriesArray, state) => {
                                    const inputValue = state.inputValue.toLowerCase();
                                    return countriesArray.filter(option =>
                                        option.toLowerCase().startsWith(inputValue)
                                    );
                                }}
                                onChange={(e, v) => handleStateName(v)}
                                disabled={(route === "existingUser" ? true : false) || CountryId === ""}
                                value={StateId}
                                isOptionEqualToValue={(option, value) => option === value}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        sx={{ margin: '7px', textAlign: 'left', width: '16rem' }}
                                        label={t('state')}
                                        fullWidth={false}
                                        required
                                        disabled={(route === "existingUser" ? true : false) || CountryId === ""}
                                        autoComplete={false}
                                        InputLabelProps={{
                                            sx: {
                                                '& .MuiFormLabel-asterisk': {
                                                    color: 'red',
                                                },
                                            },
                                            '&.MuiInputLabel-shrink': {
                                                fontSize: '1.5rem', // Works when label shrinks (i.e., floats)
                                              },
                                              transition: 'all 0.2s ease', // Make it a bit bigger when focused
                                            
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid container className="password-grid">
                            {/* City select Dropdown */}
                            <Autocomplete
                                options={comCityArray}
                                filterOptions={(countriesArray, state) => {
                                    const inputValue = state.inputValue.toLowerCase();
                                    return countriesArray.filter(option =>
                                        option.toLowerCase().startsWith(inputValue)
                                    );
                                }}

                                onChange={(e, v) => handleCityName(v, "autoComplete")}
                                isOptionEqualToValue={(option, value) => option === value}
                                value={CityId}

                                disabled={(route === "existingUser" ? true : false) || StateId === ""}

                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        sx={style.city}
                                        label={t('city')}
                                        fullWidth={false}
                                        disabled={(route === "existingUser" ? true : false) || StateId === ""}
                                        autoComplete={false}
                                        error={companyCityError}
                                        helperText={companyCityError ? t('firstName_lastName_RegexValidation') : ""}

                                    />
                                )}
                            />
                            {/* Zipcode */}
                            <TextField
                                sx={style.ZipCode}
                                label={t('zipcode')}
                                value={formik.values.ZipCode}
                                name="ZipCode"
                                id="ZipCode"
                                onChange={handleChangeZipcode}
                                error={(formik.touched.ZipCode && Boolean(formik.errors.ZipCode)) || throwInvalidZipcodeError_Company}
                                helperText={(formik.touched.ZipCode && formik.errors.ZipCode) || (throwInvalidZipcodeError_Company && t('zipcodeErrorMessage'))}
                                disabled={route === "existingUser" ? true : false}
                                autoComplete={false}
                                inputProps={{ maxLength: 150 }}

                            />
                        </Grid>
                        {/* Address1 */}
                        <div className="password-grid">
                            <TextField
                                sx={style.address}
                                label={t('address1')}
                                id='address1'
                                name='address1'
                                fullWidth={false}
                                value={formik.values.address1}
                                onChange={formik.handleChange}
                                error={formik.touched.address1 && Boolean(formik.errors.address1)}
                                helperText={formik.touched.address1 && formik.errors.address1}
                                disabled={route === "existingUser" ? true : false}
                                autoComplete={false}
                                inputProps={{ maxLength: 250 }}

                            />
                        </div>
                        {/* Address2 */}
                        <div className="password-grid">
                            <TextField
                                sx={style.address2}
                                label={t('address2')}
                                id='address2'
                                name='address2'
                                fullWidth={false}
                                value={formik.values.address2}
                                onChange={formik.handleChange}
                                error={formik.touched.address2 && Boolean(formik.errors.address2)}
                                helperText={formik.touched.address2 && formik.errors.address2}
                                disabled={route === "existingUser" ? true : false}
                                autoComplete={false}
                                inputProps={{ maxLength: 250 }}

                            />
                        </div>
                    </>
                }
            </div>
        </form>
    )
}

export default OrganisationInformation;